<template>
  <div class="topBanner">
    <img src="../../assets/course_center_bg.png" />
  </div>
</template>

<style scoped>
.topBanner {
  position: relative;
  top: 0px;
  left: 0px;
  right: 0px;
  min-width: 1200px;
  z-index: 2;
  height: 170px;
  margin-top: 64px;
}

.topBanner img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>